import { render, staticRenderFns } from "./InfoBasicView.vue?vue&type=template&id=17951898&scoped=true&"
import script from "./InfoBasicView.vue?vue&type=script&lang=js&"
export * from "./InfoBasicView.vue?vue&type=script&lang=js&"
import style0 from "./InfoBasicView.vue?vue&type=style&index=0&id=17951898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17951898",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCard,VChip})
